export default __webpack_public_path__ + "static/media/junkrat-laugh.7eaafa68.mp3";